export default "__VITE_ASSET__Ob2qRfm8__"